import { Update } from "../components/holdings-project-register/Update";
import { SpaceBetween } from "@cloudscape-design/components-themed";
import { PERMISSIONS } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

/* 
ホールディングス案件照会・更新画面
 */
const HoldingsUpdate = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.HD);
  return (
    <SpaceBetween size="l">
      <Update />
    </SpaceBetween>
  );
};

export default HoldingsUpdate;
